export default __webpack_public_path__ + "static/media/transaction-reward.46448155.svg";